<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="moduleForm">
		 <!-- NOME * -->
		<div class="grid">
			<div class="col-12">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Name, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.Name, 'label')">{{ 'NAME' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.Name, 'borderInput')">
					<input type="text" pInputText
						[ngClass]="dynamicInputTextWidth()"
						formControlName="Name"
						autocomplete="module-name"
						placeholder="{{ 'NAME' | translate }}"
						maxlength="48"
					/>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
	   </div>
	   <!-- FIRMWARE * -->
	   <div class="grid">
			<div class="col-12 text-sm flex justify-content-start align-items-center flex-wrap">
				<div class="">{{'FWVersion' | translate }}: {{(module.FWVersion) ? (module.FWVersion) : ('NO_TASK_INFO_AVAILABLE' | translate)}}</div>
			</div>
		</div>
		<!-- SETTINGS * -->
		<div class="grid">
			<div class="col-12 flex align-items-center justify-content-center text-3xl font-medium">
				{{ 'SETTINGS' | translate }}
			</div>
			<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
				<p-tag icon="pi cm-alert" [value]="('KEYPADS_WARNING' | translate)" severity="warning"></p-tag>
			</div>
		</div>
		<div *ngFor="let setting of mtmacConfig; let i=index;">
			<div *ngIf="isSettingsVisible(setting)" [class]="onExtendedMobile() ? 'grid mt-1' : 'col-12 flex align-items-center justify-content-between px-0 pb-0' ">
				<ng-container>
					<div *ngIf="setting.Type === 'int'" [class]="onExtendedMobile() ? 'col-12 p-1 flex align-items-center justify-content-center text-center' : 'col-6 pl-0 flex align-items-center justify-content-start text-start' ">{{ getTranslate(setting.Name, true) }}</div>
					<div *ngIf="setting.Type === 'int'" [class]="onExtendedMobile() ? 'col-12 pt-0' : 'col-6 px-0 py-1'" class="flex align-items-center justify-content-center">
						<div class="flex align-items-center justify-content-center w-full">
							<p-button pTooltip="{{ 'DECREASE' | translate }}"
									[disabled]="isSliderMin(setting)"
									tooltipPosition="bottom" icon="pi cm-minus" size="large"
									(click)="setSliderValue(setting, -1)" [rounded]="false" [text]="true" severity="primary"
									class="pr-3">
							</p-button>
							<div>{{formattedSliderMin(setting)}}</div>

							<div class="flex flex-column w-full mx-4"> <!-- !! TO CHECK IF VARIANT=FILLED IS OK (punto al posto della virgola)-->
								<p-inputNumber mode="decimal" [useGrouping]="false" variant="filled"
										[formControlName]="setting.Name" 
										class="flex w-full"
										styleClass="flex w-full"
										[min]="setting.Min"
										[max]="setting.Max"
										(onBlur)="onChangeInputSlider(setting)">
								</p-inputNumber>
								<p-slider [formControlName]="setting.Name" class="w-full" [step]="setting.StepSize"
										[min]="setting.Min"
										[max]="setting.Max"
										(onChange)="onChangeSlider(setting)">
								</p-slider>
							</div>
								
							<div>{{ formattedSliderMax(setting) }}</div>
							<p-button pTooltip="{{ 'INCREASE' | translate}}"
										[disabled]="isSliderMax(setting)"
										tooltipPosition="bottom" icon="pi cm-plus" size="large"
										(click)="setSliderValue(setting, 1)" [rounded]="false" [text]="true" severity="primary"
										class="pl-3">
							</p-button>
						</div>
					</div>
					<!-- !! TO CHECK LAYOUT AND FEATURE -->
					<div *ngIf="setting.Type === 'numeric'">
						<div class="flex justify-content-between flex-wrap" >
							<div class="flex align-items-center justify-content-center">{{ 'DEFINE_DELAY_TIME' | translate }} *</div>
							<div class="flex align-items-center justify-content-center">
								<p-inputNumber [formControlName]="setting.Id" step="1" [useGrouping]="false" [maxFractionDigits]="0" [showButtons]="true"
										incrementButtonClass="p-0" decrementButtonClass="p-0 border-noround"
										[max]="setting.Max"
										[min]="setting.Min">
								</p-inputNumber>
							</div>
						</div>
					</div>
					<div *ngIf="setting.Type === 'intset'" class="col-12 px-0" [class]="onExtendedMobile() ? '' : 'pb-0'">
							<div class="flex justify-content-between flex-wrap border-bottom-1 border-100" [ngClass]="dynamicBorderLabelMobile('borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(setting.Name, true) }}</div>
								<div class="flex align-items-end justify-content-center gap-2" [ngClass]="dynamicBorderLabelMobile('borderInput')">
									<p-dropdown [options]="setting.Values"
										[ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
										[formControlName]="setting.Name">
										<ng-template pTemplate="selectedItem">
											<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
												<div class="flex align-items-center">{{ (f[setting.Name]) ? getTranslate(f[setting.Name].value.Label, false) : "" }}</div>
											</div>
										</ng-template>
										<ng-template let-controlItem pTemplate="item">
											<div class="item">
												<div class="flex justify-content-center">{{ getTranslate(controlItem.Label, false)}}</div>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>
							<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
							<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
					</div>
					<div *ngIf="setting.Type === 'bool'" class="col-12 px-0" [class]="onExtendedMobile() ? '' : 'pb-0'">
							<div class="flex justify-content-between flex-wrap border-bottom-1 border-100" [ngClass]="dynamicBorderLabelMobile('borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(setting.Name, true) }}</div>
								<div class="flex align-items-end justify-content-center gap-2" [ngClass]="dynamicBorderLabelMobile('borderInput')">
									<p-dropdown [options]="setting.Values"
										[ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
										[formControlName]="setting.Name">
										<ng-template pTemplate="selectedItem">
											<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
												<div class="flex align-items-center">{{ (f[setting.Name]) ? getTranslate(f[setting.Name].value.Label, false) : "" }}</div>
											</div>
										</ng-template>
										<ng-template let-controlItem pTemplate="item">
											<div class="item">
												<div>{{ getTranslate(controlItem.Label, false)}}</div>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>
							<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
							<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
					</div>
					<div *ngIf="setting.Type === 'str'" class="col-12 px-0" [class]="onExtendedMobile() ? '' : 'pb-0'">
							<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(setting.Name,'borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(setting.Name,'label')">{{ setting.Name }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(setting.Name,'borderInput')">
									<input type="text" pInputText
										[ngClass]="dynamicInputTextWidth()"
										[formControlName]="setting.Name"
										placeholder="{{ setting.Name }}"
										maxlength="{{setting.Max}}"
									/>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(setting.Name)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>
					<div *ngIf="setting.Type === 'tzlist'" class="col-12 px-0 pb-0">
							<div class="flex justify-content-between flex-wrap border-bottom-1 border-100" [ngClass]="dynamicBorderLabelMobile('borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('label')">{{ getTranslate(setting.Name, true) }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="dynamicBorderLabelMobile('borderInput')">
									<p-dropdown [options]="timezones"
										[ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center text-center"
										[formControlName]="setting.Name">
										<ng-template pTemplate="selectedItem">
											<div class="item" class="flex align-items-center justify-content-center text-center pl-5">
												<div class="flex align-items-center">{{ (f[setting.Name]) ? f[setting.Name].value : "" }}</div>
											</div>
										</ng-template>
										<ng-template let-controlItem pTemplate="item">
											<div class="item">
												<div>{{ controlItem}}</div>
											</div>
										</ng-template>
									</p-dropdown>
								</div>
							</div>
							<!-- NO VALIDATOR HERE -> SET DEFAULT VALUE FOR DROPDOWN AND REMOVE 'small' MESSAGE -->
							<!-- <small *ngIf="showErrorRequiredMessage(this.f.settingValue)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small> -->
					</div>
				</ng-container>
			</div>
		</div>
	
	   <div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple
				label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1"
				[ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()"
					label="{{ 'CANCEL' | translate }}"
					class="p-button-secondary text-xl font-normal mt-2 mx-1"
					[ngClass]="dynamicButtonWidth()">
			</button>
	   </div>
	</form>
</div>